import React from 'react';
import { CommercialSolutions } from '../components/CommercialSolutions';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation';
interface CommercialPageProps {
  onNavigate: (page: PageType) => void;
}
export function CommercialPage({
  onNavigate
}: CommercialPageProps) {
  return <main data-id="element-219">
      <CommercialSolutions onNavigate={onNavigate} data-id="element-220" />
    </main>;
}